import React from "react";
import styled from "styled-components";
import { SCREEN_WIDTH_BREAKPOINT } from "constant/common_constants";
import MainNavItem from "./MainNavItem";
import { NAV_ELEMENTS } from "constant/navigation";
import DotsLine from "components/common/view_util/DotsLine";
import MainNavigationSmallScreen from "./MainNavigationSmallScreen";
import GroupNavigation from "./GroupNavigation";
import MainNavGroup from "./MainNavGroup";

type MainNavigationProps = {
  showMenu: boolean;
  setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
};

const MainNavigation = ({ showMenu, setShowMenu }: MainNavigationProps) => {
  const navItemClickHandle = () => setShowMenu(false);
  const toggleMenu = () => setShowMenu((prev) => !prev);

  return (
    <>
      <MobileTopBar>
        <LogoWrapper>
          <img src="/images/logo.png" alt="Logo" />
        </LogoWrapper>

        <HamburgerWrapper>
          <MainNavigationSmallScreen
            showMenu={showMenu}
            navItemClickHandle={navItemClickHandle}
            menuShowClickHandle={toggleMenu}
          />
        </HamburgerWrapper>
      </MobileTopBar>

      <ContentWrapper>
        <Div>
          <img src="/images/logo.png" alt="Logo" />
          <MainNavGroup>
            <MainNavItem navElement={NAV_ELEMENTS.HOME} />
          </MainNavGroup>
          <DotsLine />
          <GroupNavigation />
          <MainNavGroup>
            <MainNavItem navElement={NAV_ELEMENTS.ABOUT} />
            <MainNavItem navElement={NAV_ELEMENTS.COPYRIGHT} />
          </MainNavGroup>
          <DotsLine />
          <MainNavGroup>
            <MainNavItem navElement={NAV_ELEMENTS.ARTISTS} />
            <MainNavItem
              navElement={NAV_ELEMENTS.ART_MOVEMENTS_AND_PHENOMENA}
            />
            <MainNavItem navElement={NAV_ELEMENTS.MUZEJ_SAVREMENE_UMETNOSTI} />
          </MainNavGroup>
          <DotsLine />
        </Div>
      </ContentWrapper>
    </>
  );
};

const Div = styled.div`
  display: none;
  flex-direction: column;
  margin-top: 0;

  @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    display: flex;
  }
`;

// const MobileTopBar = styled.div`
//   display: flex;
//   align-items: flex-start;
//   justify-content: center;
//   position: relative;
//   padding-top: 10px;

//   @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
//     display: none;
//   }
// `;

const MobileTopBar = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  width: 100vw;
  overflow-x: hidden;
  padding-top: 10px;

  @media (min-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    display: none;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  img {
    max-height: 80px;
  }
`;

const HamburgerWrapper = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
`;

const ContentWrapper = styled.div`
  @media (max-width: ${SCREEN_WIDTH_BREAKPOINT}) {
    display: none;
  }
`;

export default MainNavigation;
